import React from 'react';

const CommentContext = React.createContext({
  isMe: false,
});

export default CommentContext;
